<!-- eslint-disable vue/no-unused-vars -->
<template>
  <section class="epochs-page">
    <Navbar />
    <section class="hero custom-height fixed-nav responsive-pad ">
      <div class="hero-head pt-4 pb-4">
        <p class="title">
        Epochenverwaltung
        </p>
      </div>
    </section>
    <div class="hero-body">
     <b-table class="app-table"
       :data="epochs"
       :bordered="false"
       :striped="false"
       :narrowed="false"
       :hoverable="true"
       :loading="false"
       :focusable="false"
       :mobile-cards="true"
       :paginated="false"
       :detailed="true">
       <b-table-column field="startDate" label="Startdatum" sortable>
        <template #default="props1">
        {{ dateFormat(props1.row.start) }}
        </template>
       </b-table-column>
       <b-table-column field="endDate" label="Enddatum" sortable>
        <template #default="props1">
        {{ dateFormat(props1.row.end) }}
        </template>
      </b-table-column>
      <b-table-column field="endDate" label="Aktionen" sortable>
        <template #default="props1">
        <button class="button is-small is-danger m-0" @click="delete_epoch(props1.row)">
          <font-awesome-icon class="icon" :icon="['fa', 'trash']"/>
        </button>
        </template>
      </b-table-column>
      <template v-slot:detail="props1">
        <b-table class="app-table" :data="props1.row.classes"
          :hoverable="true" :mobile-cards="true">
          <b-table-column field="teacher" label="Lehrer">
            <template #default="props">
              <EpochTeacherSelect v-if="editmode" :value="props.row.teacher" :teachers="teachers"
                @input="select($event, props.row, props1.row)" />
              <span v-else>{{ display(props.row.teacher) }}</span>
            </template>
          </b-table-column>
          <b-table-column field="subject" label="Fach">
            <template v-if="!editmode" #default="props">
            {{ props.row.subject }}
            </template>
            <template v-else #default="props">
            <b-select v-model="props.row.subject" placeholder="Fach auswählen">
              <option v-for="subject in classes" :key="subject" :value="subject">
                {{ subject }}
              </option>
            </b-select>
          </template>
          </b-table-column>
          <b-table-column field="class" label="Klasse">
            <template #default="props">
            {{ props.row.class }}
            </template>
          </b-table-column>
        </b-table>
        <Button v-if="!editmode" :text="'Bearbeiten'"
        :type="'hasIcon'" class="background-color-client"
        :icon="['fas', 'pen']" @click="editmode = true"/>
        <Button v-if="editmode" :text="'Speichern'"
        :type="'hasIcon'" class="background-color-client"
        :icon="['fas', 'check']" @click="save_epoch(epochs.indexOf(props1.row))"/>
      </template>
     </b-table>
     <Button :text="'Epoche Hinzufügen'" :type="'hasIcon'" class="background-color-client"
       :icon="['fas', 'plus']" @click="toggleAddEpoch()"/>
      <div class="modal is-active" v-if="addEpochModal">
        <div class="modal-background"></div>
        <div class="card">
        <div class="modal-card-head">
          <h3 class="subtitle">Neue Epoche hinzufügen</h3>
        </div>
        <div class="modal-card-body">
          <b-field label="Epoche">
            <b-field label="Startdatum" class="mb-2">
              <b-input type="date" v-model="new_epoch.start" required></b-input>
            </b-field>
            <b-field label="Enddatum" class="mb-2">
              <b-input type="date" v-model="new_epoch.end" required></b-input>
            </b-field>
          </b-field>
        </div>
        <div class="modal-card-foot">
          <button class="button" @click="toggleAddEpoch()">Abbrechen</button>
          <Button :text="'Epoche hinzufügen'" :type="'zoom'"
          @click="add_epoch()" :disabled="!isFilledOut"/>
        </div>
        </div>
      </div>
      <div v-if="epochs.length === 0" class="notification is-warning">
        Keine Epochen verfügbar. Bitte fügen Sie eine neue Epoche hinzu.
      </div>
    </div>
    <Footer />
</section>
</template>

<script>
/* eslint-disable arrow-body-style */

import Navbar from '../components/Common/Navbar.vue';
import Footer from '../components/Common/Footer.vue';
import Button from '../components/Common/Button.vue';
import formatting from '../mixins/formatting';
import EpochTeacherSelect from '../components/Common/EpochTeacherSelect.vue';

export default {
  components: {
    Navbar,
    EpochTeacherSelect,
    Footer,
    Button,
  },
  created() {
    this.$store.dispatch('Teachers/load');
  },
  mixins: [formatting],
  data() {
    return {
      search_name: '',
      showDetailIcon: true,
      addEpochModal: false,
      newEpoch: {
        subject: '',
        class: '',
        teacher: {},
      },
      loading: false,
      new_epoch: {
        start: '',
        end: '',
      },
      edit_modal: false,
      editmode: false,
      classes: [
        'Geschichte',
        'Biologie',
        'Chemie',
        'Deutsch',
        'Erdkunde',
        'Physik',
        'Mathe',
        'Berufspraktikum',
        'Rechtskunde',
        'Kunst',
        'Plastizieren',
        'Praktikum',
      ],
    };
  },
  computed: {
    epochs() {
      return this.$store.getters['Account/epochs'];
    },
    dropdownLabel() {
      if (this.selected_epoch) {
        return `${this.selected_epoch.start} / ${this.selected_epoch.end}`;
      }
      return 'Epoche auswählen';
    },
    isFilledOut() {
      return this.new_epoch.start !== '' && this.new_epoch.end !== '';
    },
    teachers() {
      return this.$store.getters['Teachers/get_teachers'];
    },
  },
  methods: {
    toggleAddEpoch() {
      this.addEpochModal = !this.addEpochModal;
    },
    display(teacher) {
      return teacher ? [teacher.firstname, teacher.lastname].filter(Boolean).join(' ') : 'Nicht zugeordnet';
    },
    save_epoch(epochIndex) {
      this.$store.dispatch('Account/save_epoch', epochIndex).then((res) => {
        if (res) {
          this.editmode = false;
          this.$buefy.toast.open({
            message: 'Epoche erfolgreich gespeichert',
            type: 'is-success',
          });
        } else {
          this.$buefy.toast.open({
            message: 'Fehler beim Speichern der Epoche',
            type: 'is-danger',
          });
        }
      });
    },
    add_epoch() {
      this.$store.dispatch('Account/add_epoch', {
        start: this.new_epoch.start,
        end: this.new_epoch.end,
      }).then((res) => {
        if (res) {
          this.$buefy.toast.open({
            message: 'Epoche erfolgreich hinzugefügt',
            type: 'is-success',
          });
          // reset form
          this.addEpochModal = false;
          this.new_epoch.start = '';
          this.new_epoch.end = '';
        } else {
          this.$buefy.toast.open({
            message: 'Fehler beim Hinzufügen der Epoche',
            type: 'is-danger',
          });
        }
      });
    },
    delete_epoch(epoch) {
      this.$buefy.dialog.confirm({
        title: 'Epoche löschen',
        message: 'Sind Sie sicher, dass Sie diese Epoche löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        cancelText: this.$t('common.cancel'),
        confirmText: 'Epoche löschen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch('Account/delete_epoch', epoch).then((res) => {
            if (res) {
              this.$buefy.toast.open({
                message: 'Epoche erfolgreich gelöscht',
                type: 'is-success',
              });
            } else {
              this.$buefy.toast.open({
                message: 'Fehler beim Löschen der Epoche',
                type: 'is-danger',
              });
            }
          }).catch(() => {
            this.$buefy.toast.open({
              message: 'Fehler beim Löschen der Epoche',
              type: 'is-danger',
            });
          });
        },
      });
    },
    select(teacher, row, epoch) {
      const epochIndex = this.epochs.indexOf(epoch);
      const classIndex = epoch.classes.indexOf(row);
      this.$store.commit('Account/set_teacher_epoch', { teacher, epochIndex, classIndex });
    },
    reset_selected() {
      this.loading = true;
      this.selected_teacher = '';
      this.name = '';
      this.dates = [];
      this.teacher_selected = false;
      this.edit_modal = false;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.epochs-page {
  min-height: 100vh;
  .modal-card-body {
    width: 30rem;
    height: 10rem;
  }
}
</style>
